










































import Vue from "vue";

export default Vue.extend({
  name: "CustomSelect",
  props: {
    value: {
      type: [String, Number, Object],
      required: false
    },
    items: {
      type: Array as () => Array<any>,
      required: true
    },
    itemText: {
      type: String,
      default: "text"
    },
    is_object: {
      type: Boolean,
      default: false
    },
    return_object: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selected: this.value // Sync v-model value with local data
    };
  },
  computed: {
    computedItemValue(): any {
      return !this.is_object ? "value" : null;
    }
  },
  watch: {
    value(val: any) {
      this.selected = val;
    },
    selected(val: any) {
      this.$emit("input", val);
    }
  },
  methods: {
    change(val: any) {
      this.$emit("change", val);
    }
  }
});
